/**
 * plaudit.SlideManager
 * Used
 *
 * Dependencies:
 *  - jQuery
 */
// TODO: Change to a listener framework (e.g. addEventListener( "change", function ); ) so multiple "onChange" can exist.
// TODO: Consider making a jquery wrapper to make slideshows that comebine SlideManager and Stopwatch easy to create for those used to using JQuery style coding. (only issue is that it would inevitably be less powerful and flexible)
!(function($){
	"use strict";
	var plaudit		= window.plaudit || {}
		,className	= "SlideManager"	// TODO: What is a more generic name? "slide" is too specific while it could be use for other applications
		,clazz		= null
		,defaults = {
			slides:			null		// An array or array like object of slides.
			,onChange:		null		/* Function to be called when slides change.
			 							 * Passed an object of { currentSlide, newSlide }
			 							 * Returning false will cancel updating the manager's index.
			 							 */
			,randomizeOrder: false
			,randomizeStart: false
			,loop:			true
		};

	function keepInRange( idx, length, loop ) {
		if ( idx >= length ) {
			idx = ( loop )? idx-length : length-1;
		} else if ( idx < 0 ) {
			idx = ( loop )? length+idx : 0;
		}
		return idx
	}

	clazz = plaudit[className] = function( options ) {
		var self			= this
			,settings		= self.settings = $.extend( {}, defaults, options )
			,idx			= null
			,slides			= null;

		// Setup
		slides = $.makeArray( settings.slides ); // We work with the private slide, not settings.slides (which stays untouched).
		if( settings.randomizeOrder ) {
			slides.sort(function() { return 0.5 - Math.random() });
		}
		idx = (settings.randomizeStart)? Math.floor(Math.random()*slides.length) : 0;

		// Methods
		function notifyOnChange( currentIdx, newIdx ) {
			var data		= {
				currentSlide:	(currentIdx === null)	? null : slides[currentIdx]
				,newSlide:		(newIdx === null)		? null : slides[newIdx]
			};
			return settings.onChange.apply( self, [data] );
		}
		function jumpTo( i, isRelative ) { // isRelative is optional. Default is false (aka absolute). If absolute, i is 0 based.

			var newIdx		= (!!isRelative)? idx + i : i;
			newIdx			= keepInRange( newIdx, slides.length, settings.loop );

			if ( newIdx !== idx ) {
				var shouldContinue	= notifyOnChange(
					idx,
					newIdx
				);
				if ( shouldContinue !== false ) {
					idx = newIdx;
				}
			}

			return getCurrentSlide();
		}

		function getCurrentSlide() {
			return slides[idx];
		}

		function indexOfSlide( obj ) {
			// Search for obj within slides and return its index (or -1 if not found).
			// Especially helpful if you need to find the index of a slide when the list has been randomized.
			return $.inArray( obj, slides );
		}

		// Go to first initial slide
		notifyOnChange( null, idx );

		// == Public ==
		self.next				= function() { return jumpTo( 1,	true ); };
		self.previous			= function() { return jumpTo( -1,	true ); };
		self.jumpTo				= jumpTo;
		self.getCurrentSlide	= getCurrentSlide;
		self.indexOfSlide		= indexOfSlide;
	};
	clazz.defaults = defaults; // Make the defaults public
})(jQuery);



